import React, { useRef, useEffect, useState, useReducer } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import { Skeleton, TextField, Tooltip } from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import InputAdornment from "@mui/material/InputAdornment";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import Actions from "./Actions";

export default function RegularTableRow({
  index,
  editIndex,
  saved,
  currentFocus,
  validate,
  setSaved,
  setEditIndex,
  rowCopy,
  setRowCopy,
  columns,
  options,
  filteredColumns,
  provided,
  row,
  snapshot,
}) {
  const filter = createFilterOptions();

  function handleTextFieldChange(e, column) {
    if (column.type === "number") {
      setRowCopy({
        ...rowCopy,
        [column.id]: parseFloat(e.target.value),
      });
    } else {
      //console.log("here", column);
      setRowCopy({
        ...rowCopy,
        [column.id]: e.target.value,
      });
    }
  }

  function handleTextFieldBlur(e) {
    //console.log(":2");
    if (e.relatedTarget?.id === e.target?.id) e.stopPropagation();

    if (e.relatedTarget?.id === "button") return;

    if (e.relatedTarget?.id.includes("cell")) {
      //console.log("related");
      // e.relatedTarget.focus();
    } else {
      validate(row);
    }
  }

  function handleCellClick(e, column, i) {
    if (options.editable === false || column.edit === false) return;

    if (editIndex.rowIndex === index) {
      e.stopPropagation();
      return;
    }

    setEditIndex({
      rowIndex: index,
      columnIndex: i,
    });
  }

  useEffect(() => {
    setTimeout(() => currentFocus.current[editIndex.columnIndex]?.focus(), 500);
  }, [editIndex]);

  function handleKeyUp(e, index, i) {
    const restOfRow = columns.filter((item, itemIndex) => itemIndex > i);
    const isEditable = restOfRow
      .map((item) => item?.edit !== false)
      .includes(true);

    if (e.key === "Enter") {
      if (columns[i + 1]) {
        if (
          (columns[i + 1].hasOwnProperty("edit") && columns[i + 1] !== false) ||
          columns[i + 1].hasOwnProperty("edit") === false
        ) {
          // console.log("donertgertew");

          setEditIndex({
            rowIndex: index,
            columnIndex: i + 1,
          });
        }

        if (!isEditable) {
          validate(row);

          options?.newRecord?.(setEditIndex, setRowCopy);
        }
      }
    }
  }

  return (
    <TableRow
      key={index}
      sx={{
        display: "flex",
        justifyContent: "spaceAround",
        "&:last-child td, &:last-child th": {
          border: 0,
        },
      }}
      onClick={() => {
        options.onRowClick?.(row);

        setRowCopy(row);
      }}
      {...provided.draggableProps}
      ref={provided.innerRef}
      isDragging={snapshot.isDragging}
      className="flex ma2 items-center"
    >
      {options.dragable && (
        <TableCell sx={{ width: "18px" }} {...provided.dragHandleProps} handle>
          <DragHandleIcon />
        </TableCell>
      )}

      {filteredColumns.map((column, i) => {
        const updatedColumn = columns.find((item) => item.id === column.id);
        // console.log(updatedColumn)

        if (column.view === false) {
          return null;
        } else {
          return (
            <TableCell
              sx={{
                textAlign: column.align || options.columnAlign || "left",
                minWidth: column.minWidth || options.columnMinWidth || "150px",
                maxWidth: column.maxWidth || null,
                // minHeight: "50px",
                width: "100%",
              }}
              component="th"
              scope="row"
              key={i + index + i}
              onClick={(e) => handleCellClick(e, column, i)}
            >
              {options?.isLoading && <Skeleton />}

              {editIndex.rowIndex === index &&
                options.editable !== false &&
                column.edit !== false &&
                (column.editComponent === undefined ||
                  column.editComponent === "textField") && (
                  <TextField
                    value={rowCopy[column.id]}
                    key={index + i}
                    type={column.type}
                    onKeyUp={(e) => handleKeyUp(e, index, i)}
                    id={`cell${index}`}
                    size="small"
                    error={
                      column.required === true &&
                      saved === false &&
                      !rowCopy[column.id]
                    }
                    // autoFocus={
                    //   editIndex.rowIndex === index &&
                    //   editIndex.columnIndex === i
                    //     ? true
                    //     : false
                    // }
                    inputRef={
                      editIndex.rowIndex === index &&
                      ((el) => (currentFocus.current[i] = el))
                    }
                    onChange={(e) => handleTextFieldChange(e, column)}
                    onBlur={(e) => {
                      // console.log("3");
                      handleTextFieldBlur(e);
                    }}
                  />
                )}

              {editIndex.rowIndex === index &&
                options.editable !== false &&
                column.edit !== false &&
                column.editComponent?.type === "selectField" && (
                  <Autocomplete
                    value={rowCopy[column.id]}
                    key={index + i}
                    onBlur={(e) => {
                      //console.log("blur", e);
                      if (e.relatedTarget?.id === e.target?.id)
                        e.stopPropagation();

                      if (e.relatedTarget?.id === "button") return;

                      if (e.relatedTarget?.id.includes("cell")) {
                        e.stopPropagation();
                        //console.log("related");
                        e.relatedTarget.focus();
                      } else {
                        validate(row);
                      }
                    }}
                    id={`cell${index}`}
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {updatedColumn.editComponent?.label}
                        </InputAdornment>
                      ),
                    }}
                    autoSelect={true}
                    onKeyUp={(e) => handleKeyUp(e, index, i)}
                    sx={{ minWidth: options?.width }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    onOpen={(e) => options.onOpen?.()}
                    onChange={(e, newValue) => {
                      setRowCopy({
                        ...rowCopy,
                        [column.id]: newValue,
                      });

                      updatedColumn.editComponent?.onChange?.(
                        newValue,
                        setRowCopy,
                        rowCopy
                      );
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option[updatedColumn.editComponent?.id] ===
                      value[updatedColumn.editComponent?.id]
                    }
                    options={updatedColumn.editComponent?.values || []}
                    getOptionLabel={(option) => {
                      // Value selected with enter, right from the input
                      if (typeof option === "string") {
                        return option;
                      }
                      // Add "xxx" option created dynamically
                      if (option.inputValue) {
                        return option.inputValue;
                      }
                      // Regular option
                      return option.title;
                    }}
                    filterOptions={(filterOptions, params) => {
                      const filtered = filter(filterOptions, params);

                      const { inputValue } = params;

                      // Suggest the creation of a new value
                      const isExisting = filterOptions.some(
                        (option) => inputValue === option.title
                      );

                      if (inputValue !== "" && !isExisting && options.add) {
                        filtered.push({
                          inputValue,
                          title: (
                            <Box
                              sx={{
                                color: "primary.light",
                                marginLeft: "10px",
                              }}
                            >{`Create "${inputValue}"`}</Box>
                          ),
                        });
                      }

                      return filtered;
                    }}
                    renderOption={(props, option) => (
                      <li {...props}>{option.title}</li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        onFocus={() => {
                          column.editComponent.onFocus?.(rowCopy);
                        }}
                        error={
                          column.required === true &&
                          saved === false &&
                          !rowCopy[column.id]
                        }
                        // autoFocus={
                        //   editIndex.rowIndex === index &&
                        //   editIndex.columnIndex === i
                        //     ? true
                        //     : false
                        // }
                        inputRef={
                          editIndex.rowIndex === index &&
                          ((el) => (currentFocus.current[i] = el))
                        }
                        sx={{
                          minWidth: options?.width,
                        }}
                        label={column.name}
                      />
                    )}
                  />
                )}

              {editIndex.rowIndex !== index &&
                !options?.isLoading &&
                (updatedColumn.options?.customCell?.(row[column.id]) ||
                  updatedColumn?.calculatedField?.(row, rowCopy) ||
                  (column.startValue || "") +
                    (row[column.id] || "") +
                    (column.endValue || ""))}

              {!options?.isLoading &&
                column.edit === false &&
                editIndex.rowIndex === index &&
                (updatedColumn.options?.customCell?.(row[column.id]) ||
                  updatedColumn?.calculatedField?.(rowCopy, row) ||
                  (column.startValue || "") +
                    (row[column.id] || "") +
                    (column.endValue || ""))}
            </TableCell>
          );
        }
      })}

      {options.actions !== false && (
        <Actions
          editIndex={editIndex}
          index={index}
          validate={validate}
          row={row}
          options={options}
          setSaved={setSaved}
          rowCopy={rowCopy}
        />
      )}
    </TableRow>
  );
}
